import _get from "lodash/get";
import styled from 'styled-components';
import { rem, lighten } from 'polished';
import headerTheme from '../../styles/headerTheme';
var HeaderContainer = styled.div.withConfig({
  displayName: "HeaderContainer",
  componentId: "sc-1dl59qg-0"
})(["background-color:", ";box-shadow:", ";height:", ";left:", ";position:", ";top:", ";transition:background-color 1s ease-in-out;width:", ";z-index:3;"], function (_ref) {
  var headerColors = _ref.headerColors,
      theme = _ref.theme;
  return headerColors ? lighten(0.05, headerColors[0]) : _get(theme, 'header.backgroundColor', headerTheme.header.backgroundColor);
}, function (_ref2) {
  var theme = _ref2.theme,
      isVertical = _ref2.isVertical;
  return isVertical ? _get(theme, 'header.shadow.verticalShadow', headerTheme.header.shadow.verticalShadow) : _get(theme, 'header.shadow.horizontalShadow', headerTheme.header.shadow.horizontalShadow);
}, function (_ref3) {
  var theme = _ref3.theme,
      isVertical = _ref3.isVertical;
  return isVertical ? '100vh' : rem(_get(theme, 'header.height', headerTheme.header.height));
}, function (_ref4) {
  var isVertical = _ref4.isVertical;
  return isVertical ? 'auto' : 0;
}, function (_ref5) {
  var isVertical = _ref5.isVertical;
  return isVertical ? 'relative' : 'fixed';
}, function (_ref6) {
  var isVertical = _ref6.isVertical;
  return isVertical ? 'auto' : 0;
}, function (_ref7) {
  var isVertical = _ref7.isVertical;
  return isVertical ? 'auto' : '100%;';
});
export default HeaderContainer;